import { call, put, takeEvery } from "redux-saga/effects";
import {
  hideCampaignSourcesListLoader,
  setCampaignSourceProfile,
  setCampaignSourcesList,
  setErrorCampaignSourceProfile,
  showCampaignSourcesListLoader,
} from "./actions";
import {
  ADD_CAMPAIGN_SOURCE,
  DELETE_CAMPAIGN_SOURCE,
  GET_CAMPAIGN_SOURCE_PROFILE,
  GET_CAMPAIGN_SOURCES_LIST,
  UPDATE_CAMPAIGN_SOURCE_PROFILE,
} from "./actionTypes";
import {
  deleteCampaignSource,
  getCampaignSourceProfile,
  getCampaignSources,
  postCampaignSource,
  putCampaignSourceProfile,
} from "../../../helpers/jwt_helper";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";

function* onGetCampaignSourcesList({ payload: data }) {
  try {
    yield put(showCampaignSourcesListLoader());
    let response = yield call(getCampaignSources, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          description: i.description === "string" ? "" : i.description,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }
    yield put(setCampaignSourcesList(response));
    yield put(hideCampaignSourcesListLoader());
  } catch (error) {
    yield put(hideCampaignSourcesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignSource({ payload: { source, data } }) {
  try {
    yield put(showCampaignSourcesListLoader());
    yield call(postCampaignSource, {
      name: source.name,
      slug: source.slug,
      description: source.description,
    });
    yield call(onGetCampaignSourcesList, { payload: data });
    yield put(hideCampaignSourcesListLoader());
    showSuccessMessage("Campaign source has been added");
  } catch (error) {
    yield put(hideCampaignSourcesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteCampaignSource({ payload: { id, data } }) {
  try {
    yield put(showCampaignSourcesListLoader());
    yield call(deleteCampaignSource, id);
    yield call(onGetCampaignSourcesList, { payload: data });
    yield put(hideCampaignSourcesListLoader());
    showSuccessMessage("Campaign source has been deleted");
  } catch (error) {
    yield put(hideCampaignSourcesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignSourceProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignSourceProfile(false));
    let response = yield call(getCampaignSourceProfile, id);
    yield put(setCampaignSourceProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorCampaignSourceProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignSourceProfile({ payload: { id, source, data } }) {
  try {
    yield put(showCampaignSourcesListLoader());
    yield call(putCampaignSourceProfile, id, {
      name: source.name,
      slug: source.slug,
      description: source.description,
    });
    yield call(onGetCampaignSourcesList, { payload: data });
    yield put(hideCampaignSourcesListLoader());
    showSuccessMessage("Campaign's source has been updated");
  } catch (error) {
    yield put(hideCampaignSourcesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignSourcesListSaga() {
  yield takeEvery(GET_CAMPAIGN_SOURCES_LIST, onGetCampaignSourcesList);
  yield takeEvery(DELETE_CAMPAIGN_SOURCE, onDeleteCampaignSource);
  yield takeEvery(ADD_CAMPAIGN_SOURCE, onAddCampaignSource);
  yield takeEvery(GET_CAMPAIGN_SOURCE_PROFILE, onGetCampaignSourceProfile);
  yield takeEvery(
    UPDATE_CAMPAIGN_SOURCE_PROFILE,
    onUpdateCampaignSourceProfile
  );
}

export default campaignSourcesListSaga;
